module.exports = __webpack_public_path__ + "img/noble-level4-img.a3327635.png";